<template>
  <el-dialog
    :visible.sync="innerVisible"
    :show-close="false"
    destroy-on-close
    :title="$t('SystemMaintenance.ServiceCodeMaintenance')"
  >
    <el-table :data="rowData">
      <el-table-column :label="$t('SystemMaintenance.ServiceCode')" prop="code" />
      <el-table-column :label="$t('SystemMaintenance.Meaning')" prop="name" />
      <el-table-column :label="$t('SystemMaintenance.Operation')">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :disabled="scope.row.default"
            @click="setDefault(scope.row)"
          >{{ scope.row.default? $t('SystemMaintenance.Defaulted') : $t('SystemMaintenance.SetAsDefault') }}</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="remove(scope.row.uuid)"
          >{{ $t('SystemMaintenance.Delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button type="primary" @click="addServiceCodeDialog.visible = true">{{ $t('SystemMaintenance.Add') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('SystemMaintenance.Close') }}</el-button>
    </div>
    <el-dialog
      title="添加服务码"
      :visible="addServiceCodeDialog.visible"
      :show-close="false"
      append-to-body
      width="400px"
      @close="handleServiceCodeClose"
    >
      <el-form label-position="top">
        <el-form-item :label="$t('SystemMaintenance.PleaseEnterTheServiceCode')">
          <el-input v-model="addServiceCodeDialog.code" :maxlength="1" />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.PleaseTheServiceCodeMeaning')">
          <el-input v-model="addServiceCodeDialog.name" :maxlength="10" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="handleSaveServiceCode">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="handleServiceCodeClose">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getGroupIdentification, addGroupIdentification, deleteGroupIdentification, defaultGroupIdentification } from '@/api/groupIdentification'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'ServiceCodeDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      addServiceCodeDialog: {
        visible: false,
        code: '',
        name: ''
      },
      rowData: [],
      loading: null
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.fetchData()
      }
    }
  },
  methods: {
    fetchData() {
      this.loading = getLoading()
      getGroupIdentification({ officeId: this.$store.getters.currentOfficeId }).then(res => {
        this.rowData = res.data.list
      }).finally(() => {
        this.loading.close()
      })
    },
    addServiceCode() {

    },
    setDefault(data) {
      console.log('data', data)
      defaultGroupIdentification({ ...data, default: true }).then(res => {
        this.$message.success(this.$t('SystemMaintenance.SuccessSetting'))
        this.fetchData()
      })
    },
    remove(uuid) {
      console.log('uuid', uuid)
      this.$confirm(this.$t('SystemMaintenance.AreToDeleteThisCode'), this.$t('SystemMaintenance.Prompt'), {
        type: 'warning'
      }).then(() => {
        deleteGroupIdentification({ uuid }).then(res => {
          this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
          this.fetchData()
        })
      })
    },
    handleSaveServiceCode() {
      console.log('handleSaveServiceCode')
      const { code, name } = this.addServiceCodeDialog
      addGroupIdentification(
        {
          code,
          default: false,
          name,
          officeId: this.$store.getters.currentOfficeId
        }
      ).then(res => {
        this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
        this.addServiceCodeDialog.code = ''
        this.addServiceCodeDialog.name = ''
        this.addServiceCodeDialog.visible = false
        this.fetchData()
      })
    },
    handleServiceCodeClose() {
      this.addServiceCodeDialog.code = ''
      this.addServiceCodeDialog.name = ''
      this.addServiceCodeDialog.visible = false
    }
  }
}
</script>

<style scoped>

</style>
